/* unplugin-vue-components disabled */import { render } from "./MenuDrawer.vue?vue&type=template&id=4a5b46a1"
import script from "./MenuDrawer.vue?vue&type=script&lang=js"
export * from "./MenuDrawer.vue?vue&type=script&lang=js"

import "./MenuDrawer.vue?vue&type=style&index=0&id=4a5b46a1&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__